import {Action, createAction, props} from '@ngrx/store';
import {IYear} from '../models/IYearModel';

export enum YearsActions {
  RETRIEVE_YEARS = '[IYear] RetrieveYears',
  YEARS_RECEIVED = '[IYear] YearsReceived',
  ERROR_RETRIEVING_YEARS = '[IYear] ErrorRetrievingYears'
}

export const retrieveYearsAction = createAction(
  YearsActions.RETRIEVE_YEARS
);

export const yearsReceivedAction = createAction(
  YearsActions.YEARS_RECEIVED,
  props<{ years: Array<IYear> }>()
);

export const retrieveYearsErrorAction = createAction(
  YearsActions.ERROR_RETRIEVING_YEARS,
  props<{ error: any }>()
);
